import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import TestimonialLayer from '../components/TestimonialLayer';

const TestimonialPage = () => {
    return (
        <MasterLayout>
            <TestimonialLayer />
        </MasterLayout>
    );
};

export default TestimonialPage;
